/*
 * Scroll reveal for .ppc-rv.
 *
 * The hidden state is gated behind html.ppc-js, which this file sets. If this
 * script never runs — blocked, errored, unsupported — the gate is absent and
 * every section renders fully visible. A reveal effect must never be able to
 * take the content down with it.
 */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !('IntersectionObserver' in window)) return;
  root.classList.add('ppc-js');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });

  function watch(scope) {
    (scope || document).querySelectorAll('.ppc-rv:not(.in)').forEach(function (el) { io.observe(el); });
  }

  function showAll() {
    document.querySelectorAll('.ppc-rv:not(.in)').forEach(function (el) { el.classList.add('in'); });
  }

  watch();
  document.addEventListener('DOMContentLoaded', function () { watch(); });

  // Theme editor swaps section markup in place; pick up whatever it just added.
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); });

  // Last resort: if anything above went wrong, don't leave the page blank.
  window.addEventListener('load', function () {
    setTimeout(function () {
      var stuck = document.querySelector('.ppc-rv:not(.in)');
      if (!stuck) return;
      var r = stuck.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) showAll();
    }, 1200);
  });
})();
